import { module } from 'modujs';
import { $html } from '../utils/dom'

export default class BannerApp extends module {

    static CLASS = {
        OPEN: 'has-banner-open',
    }

    constructor(m) {
        super(m)

        // Events
        this.events = {
            click: {
                'close': 'close'
            }
        }
    }

    //////////////
    // Lifecycle
    //////////////

    init() {
        const bannerClosed = localStorage.getItem('bannerClosed');

        if (!bannerClosed) {
            $html.classList.add(BannerApp.CLASS.OPEN);
        }
    }

    destroy() {
        super.destroy();
    }

    close() {
        $html.classList.remove(BannerApp.CLASS.OPEN);
        localStorage.setItem('bannerClosed', 'true');
    }
}
